import {
  type MutationFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { removeEmpty, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { EmailTemplate } from 'utils/types';

import { EMAIL_TEMPLATE_FORM } from '../forms/schema';
import c from '../utils/constants';

export default function useCreateEmailTemplate() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  const mutationFn: MutationFunction<
    EmailTemplate,
    EMAIL_TEMPLATE_FORM
  > = async (_payload) => {
    const api = new Api(args);

    const payload: Record<string, any> = removeEmpty(_payload);

    const data = await api.post(
      await withAcl({
        account: {
          url: 'api/v1/channels/email/templates/',
          payload,
        },
        admin: {
          url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/email/templates/`,
          payload,
        },
      }),
    );

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.TEMPLATES, {}] });
      queryClient.invalidateQueries({
        queryKey: [c.TEMPLATES, 'INFINITE', {}],
      });

      toastSuccess('Successfully created email template');
    },
  });
}
